import axios from 'axios';
import { getAuthToken } from '../../../shared/utils/authStorage';
import { BASE_URLS, ENV_CONFIG } from '../../../shared/config/env';

const popClient = axios.create({
    baseURL: BASE_URLS.POP,
    timeout: ENV_CONFIG.apiTimeout,
});

popClient.interceptors.request.use((config) => {
    const token = getAuthToken();
    if (token) config.headers['Authorization'] = `Bearer ${token}`;
    config.headers['device-platform'] = 7;
    return config;
});

export const paymentService = {
    getOrgPaymentMethods: (orgGuid) =>
        popClient.get(`/organisation/${orgGuid}/methods`, {
            params: { 'filter[is_active]': 1, expand: 'method_configuration,currencies' },
        }),

    initiateManual: (invoiceId, paymentNotes = '', currencyId = null) =>
        popClient.post('/initialise_payment/manual', {
            invoice_id: invoiceId,
            payment_notes: paymentNotes,
            currency_id: currencyId,
        }),

    initiateGateway: (gateway, invoiceId) =>
        popClient.post(`/initialise_payment/gateway/${gateway}`, { invoice_id: invoiceId }),

    verifyRazorpay: (paymentGuid, razorpayPaymentId, razorpaySignature) =>
        popClient.post(`/initialise_payment/${paymentGuid}/verify`, {
            razorpay_payment_id: razorpayPaymentId,
            razorpay_signature: razorpaySignature,
        }),

    verifyStripe: (paymentGuid, stripePaymentIntentId) =>
        popClient.post(`/initialise_payment/${paymentGuid}/verify`, {
            stripe_payment_intent_id: stripePaymentIntentId,
        }),

    // Transactions
    listTransactions: (params = {}) =>
        popClient.get('/payments', { params }),

    getTransaction: (paymentGuid) =>
        popClient.get(`/payments/${paymentGuid}`),

    // Attempts
    listAttempts: (paymentGuid, params = {}) =>
        popClient.get(`/payments/${paymentGuid}/attempts`, { params }),

    getAttempt: (paymentGuid, attemptGuid) =>
        popClient.get(`/payments/${paymentGuid}/attempts/${attemptGuid}`),
};
